import { render, staticRenderFns } from "./Level3Settings.vue?vue&type=template&id=79381cd3&"
import script from "./Level3Settings.vue?vue&type=script&lang=ts&"
export * from "./Level3Settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports